<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('medicalorder:page')">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="8" :sm="24">
              <a-form-item label="姓名">
                <a-input v-model="queryParam.orderId" allow-clear placeholder="请输入患者姓名" />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="queryParam.orderId" allow-clear placeholder="请输入订单编号"/>
              </a-form-item>
            </a-col>
            
            <a-col :md="8" :sm="24">
              <a-form-item label="项目名称">
                <a-input v-model="queryParam.prejectName" allow-clear placeholder="请输入项目名称" />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator" >
          <x-down
            v-if="hasPerm('medicalorder:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>
       
        <span slot="action"  slot-scope="text, record">
          
          <a @click="$refs.addForm.add(record)">
              详情
          </a>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
import { medicalorderPage, medicalorderExport } from '@/api/modular/interhospital/subExamination/subExamination'
  import addForm from './viewDetial.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '报告时间',
            align: 'center',
            dataIndex: 'ctstamp'
          },
          {
            title: '订单编号',
            align: 'center',
            dataIndex: 'id'
          },
          {
            title: '项目名称',
            align: 'center',
            dataIndex: 'patientname'
          },
          {
            title: '患者',
            align: 'center',
            dataIndex: 'patientsex',
            scopedSlots: { customRender: 'patientsex' },
          },
          {
            title: '患者ID',
            align: 'center',
            dataIndex: 'patientage'
          },
          
          {
            title: '病历号',
            align: 'center',
            dataIndex: 'totalfee',
          },
          {
            title: '科室',
            align: 'center',
            dataIndex: 'orderstate',
            scopedSlots: { customRender: 'orderstate' },
          },
          {
            title: '医生',
            align: 'center',
            dataIndex: 'totalfee',
          },
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return new Promise(async(resolve,reject)=>{
             const res = await medicalorderPage(Object.assign(parameter, this.queryParam))
             resolve(res.data)
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        orderstates : [
          {
            value: '',
            label: '全部',
          },
          {
            value: '1',
            label: '待支付',
          },
          {
            value: '2',
            label: '待体检',
          },
          {
            value: '8',
            label: '已完成',
          },
          {
            value: '10',
            label: '已取消',
          },
        ],
        pharmacytypes : [
          {
            value: '',
            label: '全部',
          },
          {
            value: '1',
            label: '套餐',
          },
          {
            value: '2',
            label: '单项',
          },
        ]
      }
    },
    created () {
      if (this.hasPerm('medicalorder:edit') || this.hasPerm('medicalorder:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        medicalorderExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },

      // 提交时间
      handlDate(date, dateString) {
        this.queryParam.ctstamp = dateString
      },

      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
  
</style>
